import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';
import { FuseMediaWatcherService } from '@fuse/services/media-watcher';
import { FuseNavigationService, FuseVerticalNavigationComponent } from '@fuse/components/navigation';
import { FuseNavigationItem } from '@fuse/components/navigation';
import { Navigation } from 'app/core/navigation/navigation.types';
import { NavigationService } from 'app/core/navigation/navigation.service';
import { User } from 'app/core/user/user.types';
import { UserService } from 'app/core/user/user.service';

import { environment } from 'environments/environment';

@Component({
    selector     : 'classy-layout',
    templateUrl  : './classy.component.html',
    styleUrls    : ['./classy.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone   : false
})
export class ClassyLayoutComponent implements OnInit, OnDestroy
{
    isScreenSmall: boolean;
    navigation: Navigation;
    user: User;
    version: string = environment.version;

    private _unsubscribeAll: Subject<any> = new Subject<any>();

    /**
     * Constructor
     */
    constructor(
        private _activatedRoute: ActivatedRoute,
        private _router: Router,
        private _navigationService: NavigationService,
        private _userService: UserService,
        private _fuseMediaWatcherService: FuseMediaWatcherService,
        private _fuseNavigationService: FuseNavigationService
    )
    {        
    }

    get currentYear(): number
    {
        return new Date().getFullYear();
    }

    /**
     * Navigation for sidebar (excludes Sign Out; that is in the footer).
     */
    get sidebarNavigation(): FuseNavigationItem[] {
        const defaultNav = this.navigation?.default;
        if (!defaultNav?.length) return defaultNav || [];
        return defaultNav
            .map((group) => {
                if (group.type === 'group' && group.children) {
                    const filtered = group.children.filter((c) => c.link !== '/sign-out');
                    return filtered.length ? { ...group, children: filtered } : null;
                }
                return group;
            })
            .filter(Boolean) as FuseNavigationItem[];
    }

    ngOnInit(): void
    {
        // Subscribe to navigation data
        this._navigationService.navigation$
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((navigation: Navigation) => {
                this.navigation = navigation;
            });

        //// Subscribe to the user service
        //this._userService.user$
        //    .pipe((takeUntil(this._unsubscribeAll)))
        //    .subscribe((user: User) => {
        //        this.user = user;
        //        console.warn(user);
        //    });

        var name = sessionStorage.getItem("name");

        name = name.split("@")[0];
        this.user = {
            name: name,
            email : sessionStorage.getItem("email")
        } as User;

        // Subscribe to media changes
        this._fuseMediaWatcherService.onMediaChange$
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(({matchingAliases}) => {

                // Check if the screen is small
                this.isScreenSmall = !matchingAliases.includes('md');
            });
    }

    ngOnDestroy(): void
    {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }

    toggleNavigation(name: string): void
    {
        // Get the navigation
        const navigation = this._fuseNavigationService.getComponent<FuseVerticalNavigationComponent>(name);

        if ( navigation )
        {
            // Toggle the opened status
            navigation.toggle();
        }
    }
}
